import React, { useContext, useState } from 'react';
import ParseHTML from 'html-react-parser';
import {
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  Space,
  Typography,
  Divider,
} from 'antd';
import { DrawerContext } from '../Context/DrawerContext';
import { FeedContext } from '../Context/FeedContext';
import { NotifContext } from '../Context/NotifContext';
import { ThemeContext } from '../Context/ThemeContext';
import getFontSize from '../../Assets/Utilities/FontSize';
import Parser from '../Card/Parser';

const { Text } = Typography;

const AddArticleFormDrawer = (props) => {
  const { isVisible, closeDrawer } = useContext(DrawerContext);
  const { addNewArticles, addPostLoader } = useContext(FeedContext);
  const { theme } = useContext(ThemeContext);
  const { show } = useContext(NotifContext);
  const [form] = Form.useForm();
  const [characterCount, setCharacterCount] = useState(0);
  const [description, setDescription] = useState('');

  const myRef = React.createRef();

  const setFocus = (isOpen) => {
    return isOpen && myRef.current.focus();
  };

  const onFinish = (formData) => {
    addNewArticles({
      postType: formData.postType,
      title: formData.title || '',
      description: formData.description,
    });
    form.resetFields();
    setCharacterCount(0);
    setDescription('');
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
    show(
      'error',
      'Error!',
      'Please check the inputs you have provided!',
      'topRight'
    );
  };

  const formValueChanged = (formData) => {
    setCharacterCount(formData.description.length);
    setDescription(formData.description);
  };

  return (
    <div>
      <Drawer
        title={
          <Text style={{ color: theme.drawer.text }}>What's Happening?</Text>
        }
        width='100%'
        height='100%'
        onClose={closeDrawer}
        visible={isVisible}
        placement='bottom'
        headerStyle={{
          background: theme.drawer.bg,
        }}
        bodyStyle={{
          background: theme.drawer.bg,
          padding: '0px',
        }}
        footerStyle={{
          background: theme.drawer.bg,
        }}
        afterVisibleChange={setFocus}
      >
        <Row>
          <Col xs={24} sm={16} md={16} lg={12}>
            <Form
              form={form}
              onValuesChange={formValueChanged}
              layout='vertical'
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={{
                postType: 'twitter_card',
              }}
              hideRequiredMark
            >
              <Form.Item
                name='description'
                label={
                  <Text
                    style={{
                      color: theme.drawer.text,
                      padding: '4px 24px',
                    }}
                  >
                    Start writing below
                  </Text>
                }
                rules={[
                  {
                    required: true,
                    message: `Your update can't be empty`,
                  },
                ]}
                style={{
                  borderStyle: 'none',
                  borderColor: 'Transparent',
                  overflow: 'auto',
                }}
              >
                <Input.TextArea
                  style={{
                    fontSize: getFontSize(characterCount),
                    background: theme.drawer.bg,
                    color: theme.drawer.text,
                    outline: 'none',
                    padding: '100px !important',
                  }}
                  rows={12}
                  ref={myRef}
                  autoFocus
                  placeholder='I was in the gym and ...'
                />
              </Form.Item>
              {/* <Text 
                style={{color:theme.drawer.text}}  
                keyboard>
                You have written {characterCount}{' '}
                {characterCount === 1 ? `character` : `characters`}
              </Text> */}
              {/* <Form.Item 
                                name="postType" 
                                label={<Text style={{color:theme.drawer.text}}>Choose a template</Text>}
                                rules={[{ 
                                    required: true, 
                                    message: 'Please select your template!' 
                                }]}
                            >
                                <Radio.Group buttonStyle="solid">
                                    <Radio.Button name="postType" value="twitter_card">Twitter Card</Radio.Button>
                                    <Radio.Button name="postType" value="article_card" disabled>Article Card</Radio.Button>
                                    <Radio.Button name="postType" value="media_card" disabled>Media Card</Radio.Button>
                                </Radio.Group>
                            </Form.Item> */}
              {/* <Form.Item
                                name="title"
                                label={<Text style={{color:theme.drawer.text}}>What's the title</Text>}
                            >
                                <Input style={{background: theme.drawer.bg, color:theme.drawer.text, outline: 'none'}} placeholder="Please enter title for the post" />
                            </Form.Item> */}
              <Form.Item
                style={{
                  // position: '-webkit-sticky',
                  position: 'sticky',
                  bottom: '0.2rem',
                  marginTop: '1rem',
                  textAlign: 'center',
                }}
              >
                <Row>
                  <Col xs={24} sm={24}>
                    <Space>
                      <Button
                        type='primary'
                        size='large'
                        shape='round'
                        loading={addPostLoader}
                        disabled={addPostLoader}
                        htmlType='submit'
                      >
                        Submit ({characterCount})
                      </Button>
                      <Button
                        size='large'
                        shape='round'
                        onClick={closeDrawer}
                        style={{ marginRight: 8 }}
                      >
                        Cancel
                      </Button>
                    </Space>
                  </Col>
                </Row>
              </Form.Item>
            </Form>
          </Col>
          <Col
            xs={24}
            sm={8}
            md={8}
            lg={12}
            style={{
              padding: '0 0.5rem',
            }}
          >
            {/* Markdown Guidelines */}
            <Divider>
              <h4
                style={{
                  color: theme.drawer.text,
                }}
              >
                Preview
              </h4>
            </Divider>
            <Text
              style={{
                color: `${theme.content.text}`,
                fontSize: getFontSize(characterCount),
              }}
            >
              {ParseHTML(Parser(description))}
            </Text>
          </Col>
        </Row>
      </Drawer>
    </div>
  );
};

export default AddArticleFormDrawer;
